// ============================================================
// ChangedList - everything this sheet says that its library original
// does not, and everything pinned over it, each with a reset.
//
// Sheet edits are not undoable, so this is where a mistake is seen and
// reversed. "Save to library" makes the changes the new original;
// "Export" takes the character out as a file, a library entry as they
// stand, or text.
// ============================================================
import type { SheetEditor } from '../../hooks/useSheetEditor';
import PinMark from './PinMark';
import styles from './Sheet.module.css';

interface Props {
  editor: SheetEditor;
  disabled: boolean;
  /** Open the character export for this combatant. */
  onExport: () => void;
}

export default function ChangedList({ editor, disabled, onExport }: Props) {
  const { changes, pins, hasOriginal } = editor;
  return (
    <div className={styles.changed} data-testid="sheet-changed">
      {!hasOriginal && (
        <div className={styles.sectionNote}>No library sheet to compare against. Save to library to make one.</div>
      )}
      {hasOriginal && changes.length === 0 && (
        <div className={styles.sectionNote}>Nothing differs from the library sheet.</div>
      )}
      {changes.map((change) => (
        <div key={change.path} className={styles.changedRow} data-testid={`change-${change.path}`}>
          <span className={styles.changedLabel}>{change.label}</span>
          <span className={styles.changedFrom}>{change.from}</span>
          <span className={styles.changedTo}>{change.to}</span>
          <button
            type="button"
            className={styles.addButton}
            aria-label={`Reset ${change.label}`}
            disabled={disabled}
            onClick={() => editor.resetChange(change)}
          >
            RESET
          </button>
        </div>
      ))}
      {pins.map((pin) => (
        <div key={`${pin.key}.${pin.leaf ?? ''}`} className={styles.changedRow}>
          <PinMark pin={pin} disabled={disabled} onReset={editor.resetPin} />
        </div>
      ))}
      <div className={styles.changedActions}>
        <button type="button" className={styles.pickerClose} data-testid="sheet-export" onClick={onExport}>
          EXPORT
        </button>
        <button
          type="button"
          className={styles.saveButton}
          data-testid="sheet-save"
          disabled={disabled}
          onClick={editor.saveToLibrary}
        >
          SAVE TO LIBRARY
        </button>
      </div>
    </div>
  );
}
